import type {
  MotionEditorWorldAddMenuState,
  MotionEditorWorldAssetFormat,
  MotionEditorWorldPrimitiveType,
  MotionEditorWorldVector3Tuple,
} from './types';

export const WORLD_TRANSFORM_CONTROL_SIZE = 1.18;
export const WORLD_POINTER_PLANE_SIZE = 400;

export const WORLD_ADD_MENU_WIDTH = 232;
export const WORLD_ADD_MENU_HEIGHT = 182;
export const WORLD_ADD_MENU_PADDING = 10;

export const WORLD_PRIMITIVES: Record<
  MotionEditorWorldPrimitiveType,
  {
    label: string;
    defaultName: string;
    y: number;
    scale: MotionEditorWorldVector3Tuple;
  }
> = {
  plane: { label: 'Plane', defaultName: 'Plane', y: 0, scale: [1.6, 1, 1.6] },
  cube: { label: 'Cube', defaultName: 'Cube', y: 0.5, scale: [1, 1, 1] },
  sphere: { label: 'Sphere', defaultName: 'Sphere', y: 0.5, scale: [1, 1, 1] },
  cylinder: {
    label: 'Cylinder',
    defaultName: 'Cylinder',
    y: 0.5,
    scale: [1, 1, 1],
  },
  cone: { label: 'Cone', defaultName: 'Cone', y: 0.5, scale: [1, 1, 1] },
  capsule: {
    label: 'Capsule',
    defaultName: 'Capsule',
    y: 0.75,
    scale: [1, 1, 1],
  },
};

export const MOTION_EDITOR_WORLD_PRIMITIVE_TYPES = Object.keys(
  WORLD_PRIMITIVES,
) as MotionEditorWorldPrimitiveType[];

export const MOTION_EDITOR_WORLD_IMPORT_FORMATS: MotionEditorWorldAssetFormat[] =
  ['glb', 'obj'];

export const CLOSED_WORLD_ADD_MENU: MotionEditorWorldAddMenuState = {
  open: false,
  x: 0,
  y: 0,
  point: [0, 0, 0],
};
